import { useContext } from "react";
import { TableContext } from "../..";
import Row from "./comps/row";

export default function Body() {
  const table = useContext(TableContext);
  const rows = table.rows?.filter((x) => !x.parentId);

  return (
    <tbody>
      {rows?.map((row, index) => {
        const children = table.rows?.filter((x) => x.parentId && x.parentId === row.ind);
        return (
          <>
            <Row key={index} row={row} index={index} />
            {!!children?.length &&
              children.map((child, i) => {
                return <Row key={i} row={child} index={i} isChild />;
              })}
          </>
        );
      })}
    </tbody>
  );
}
